var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpikeBr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 419,
    viewBox: "0 0 375 419",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M358.953 323.35L23.9377 131.484L343.847 340.487",
    stroke: "url(#paint0_radial_16640_54379)",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M485.562 308.623L449.267 10.2556L453.832 300.216",
    stroke: "url(#paint1_radial_16640_54379)",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M330.23 364.191L29.7678 356.274L317.255 394.343",
    stroke: "url(#paint2_radial_16640_54379)",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M418.977 305.031L337.411 143.529L386.669 310.839",
    stroke: "url(#paint3_radial_16640_54379)",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M312.223 424.715L134.239 457.235L308.649 457.345",
    stroke: "url(#paint4_radial_16640_54379)",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_16640_54379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(191.57 227.275) rotate(-150.908) scale(167.159 1157.89)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.247309,
    stopColor: "#D7DF23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555008,
    stopColor: "#72BF44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#028144"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_16640_54379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(467.677 159.509) rotate(-98.1671) scale(130.954 1567.43)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.247309,
    stopColor: "#D7DF23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555008,
    stopColor: "#72BF44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#028144"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_16640_54379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(180.106 359.983) rotate(-179.722) scale(130.954 1567.43)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.247309,
    stopColor: "#D7DF23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555008,
    stopColor: "#72BF44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#028144"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_16640_54379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(378.318 224.258) rotate(-117.778) scale(78.5477 752.763)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.247309,
    stopColor: "#D7DF23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555008,
    stopColor: "#72BF44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#028144"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_16640_54379",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(223.244 440.85) rotate(168.663) scale(78.5477 752.763)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.247309,
    stopColor: "#D7DF23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555008,
    stopColor: "#72BF44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#028144"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpikeBr);
export default __webpack_public_path__ + "static/media/spikeBR.ffca44751e332e62d33adbf5f7c1d5a9.svg";
export { ForwardRef as ReactComponent };